module.exports = __webpack_public_path__ + "static/media/arab-person.a2bb2a1f.svg";